export const preciseRound = (num, dec) => {
    const numSign = num >= 0 ? 1 : -1;
    return (Math.round((num * (10 ** dec)) + (numSign * 0.0001)) / (10 ** dec)).toFixed(dec);
};
